
import Vue from 'vue'
import { QInput, QSelect } from 'quasar'
import gql from 'graphql-tag'
import types from '../helpers/types'

export default Vue.extend({
    components: { QInput, QSelect },
    props: {
        entry: {
          type: Object
        },
        users: {
          type: Array,
          default: () => ([])
        },
        singleColumn: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        isLoading: false
      }
    },
    computed: <any>{
      types() {
        return types
      },
      selectedType() {
        return types.find(t => t.key == this.entry.type) || {}
      }
    },
    methods: {
      onResponsibleValue(v: string, doneFn: () => void) {
        doneFn()
        this.entry.responsible = v
        console.log({responsible: this.entry.responsible})
      },
      focusName() {
        // @ts-ignore
        this.$refs.name.focus()
      }
    }
})

